import { render, staticRenderFns } from "./TenancyHistoriesModal.vue?vue&type=template&id=22062d70&scoped=true&"
import script from "./TenancyHistoriesModal.vue?vue&type=script&lang=js&"
export * from "./TenancyHistoriesModal.vue?vue&type=script&lang=js&"
import style0 from "./TenancyHistoriesModal.vue?vue&type=style&index=0&id=22062d70&lang=scss&scoped=true&"
import style1 from "./TenancyHistoriesModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22062d70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22062d70')) {
      api.createRecord('22062d70', component.options)
    } else {
      api.reload('22062d70', component.options)
    }
    module.hot.accept("./TenancyHistoriesModal.vue?vue&type=template&id=22062d70&scoped=true&", function () {
      api.rerender('22062d70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/TenancyHistoriesModal.vue"
export default component.exports